import React from 'react';
import {
    makeStyles,
    Container,
    Grid,
    Typography,
} from '@material-ui/core';
import CompLeaveForm from './component/Form';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
}));

export default function CompLeaveRequest() {
    const mode = window.global.submitMode;
    const classes = useStyles();

    return (
        <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Container maxWidth={false} className={classes.container}>
                <CompLeaveForm 
                    mode={mode}
                />
            </Container>
        </main>
    );
}
